import React from "react";
import "./style.scss";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  useGetAboutBannerQuery,
  useGetAboutPageContentQuery,
} from "../../../../services/AboutAPI";
import { useGetBrandsDataQuery ,useGetBrandStatusQuery } from "../../../../services/homeAPI";
import Loader from "../../fullPageLoader"

function Index() {
  const settings = {
    dots: false,
    lazyLoad: 'ondemand',
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const { data, error, isLoading } = useGetAboutBannerQuery();

  const {
    data: brandsData,
    error: brandsError,
    isLoading: bransisLoding,
  } = useGetBrandsDataQuery();

  const {
    data: aboutContent,
    error: contentError,
    isLoading: contentLoading,
  } = useGetAboutPageContentQuery();

  const { data: brandsStatus } = useGetBrandStatusQuery();
  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;

  if (bransisLoding) return <Loader />;
  if (brandsError) return <p>Failed to load data</p>;

  if (contentLoading) return <Loader />;
  if (contentError) return <p>Failed to load page content</p>;

  // Assuming 'data' contains the banners for different pages
  const aboutBanner = data?.data?.find((item) => item.page_name === "About Us");

  // Get the first section of the about content
  const aboutSection = aboutContent?.data?.[0];
  console.log("aboutSection" ,aboutSection)
  return (
    <div>
      <section
        className="about-banner"
        style={{
          backgroundImage: `url(${aboutBanner?.banner_image})`,
          backgroundSize: "cover",
        }}
      >
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>ABOUT US</h1>
        </div>
      </section>


      {brandsStatus?.data?.is_active === 1 && (
        <section className="our-brands">
          <div className="container">
            <Slider {...settings}>
              {brandsData?.brands?.map((data) => (
                <div className="client-img-div">
                  <img src={data.image} alt="Alessi" className="img-fluid about-brands" loading="lazy" />
                </div>
              ))}
            </Slider>
          </div>
        </section>
      )}
    </div>
  );
}

export default Index;
